import React, { useState } from "react";
import { Form, InputGroup, FormControl } from "react-bootstrap";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const CheckboxColumn: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { name, value },
  form: { errors, setFieldValue },
  ...props
}) => {
  const [search, setSearch] = useState("");
  // let touch = touched[field.name];
  // const getValue = () => {
  //   if (props.options) {
  //     return props.isMulti
  //       ? props.options.filter(
  //           (option: any) => field.value.indexOf(option.value) >= 0
  //         )
  //       : props.options.find((option: any) => option.value === field.value);
  //   } else {
  //     return props.isMulti ? [] : ("" as any);
  //   }
  // };
  // let sortedOptions = props.options
  //   ? props.options //.sort((a: SelectOption, b: SelectOption) => a.label.localeCompare(b.label))
  //   : [];
  return (
    <Form.Group controlId={name}>
      {props.label && (
        <Form.Label>
          {props.required ? <b>{props.label}</b> : props.label}
          {props.required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      <InputGroup className="mb-3">
        <FormControl
          aria-describedby="basic-addon2"
          onChange={(e: any) => {
            setSearch(e.target.value)
          }}
        />
        <InputGroup.Append>
          <img src="/icons/search-icon.svg" alt="search" />
        </InputGroup.Append>
      </InputGroup>
      <div className="cb-speakers-container">
        {props.options.filter((option: any) => {
          // console.log(search.toLowerCase(), option.label.toLowerCase())
          return search ? option.label.toLowerCase().indexOf(search.toLowerCase()) > -1 : true
          // return true;
        }).map((option: any) => (
          <div className="custom-checkbox-speaker">
            <label htmlFor={option.value}>
              <input type="checkbox" id={option.value} onChange={(e: any) => {
                if (e.target.checked) {
                  setFieldValue(name, [...value, option.value]);
                } else {
                  setFieldValue(
                    name,
                    value.filter((val: string) => val !== option.value)
                  );
                }
              }}
              checked={value.indexOf(option.value) > -1} />
              <span className="box"></span>
              <span className="name"><i><img src="/icons/user-icon.svg" alt={option.label} /></i>{option.label}</span>
            </label>
          </div>
        ))}
      </div>
      <Form.Control.Feedback type="invalid">
        {errors[name]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default CheckboxColumn;
